// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__jjpuS","main__title":"styles_main__title__2b2oq","footer":"styles_footer__1aJM0"};